export default async function updateCampaignSectionTechnical ({ commit }, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data, section } = payload

      const { config, flat } = data

      if (config) {
        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section, data: _.cloneDeep(config) })
      }

      if (flat) {
        Object.keys(flat).forEach(key => {
          commit('SET_CAMPAIGN_FIELD', { name: key, value: _.cloneDeep(flat[key]) })
        })
      }

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
